// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'PUT',
    endpoint: '/api/percorso-acquirenti/buoni/:id/esito',
    requestBody: '{"stato":"string","dataContratto":"string","importoContratto":"number","noteEsito":"string"}',
    response: '{"success":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/buoni?societaId&stato&tipo&q',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","tipo":"string","stato":"string","emessoAt":"string","scadenzaAt":"string","dataContratto":"string","importoContratto":"string","noteEsito":"string","acquirente":"object","commessa":"object","venditore":"object"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
